<template>
  <div class="headerBuyRecognition">
    <h1>Compra de Estrellas</h1>
    <v-container>
      <v-row no-gutters>
        <v-col md="3" sm="6" class="pa-2" v-for="(item, i) in cards" :key="i">
          <v-card class="cardStyle">
            <div class="d-flex flex-no-wrap justify-space-around">
              <div>
                <v-card-title>{{ item.categoryName }}</v-card-title>
                <v-card-title class="text-h5">{{
                  item.shapeCount
                }}</v-card-title>
              </div>
              <v-avatar class="avatarStyle" size="60">
                <div class="icon-item" >
                  <img :src="item.icon"/>
                </div>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="table"
      item-key="categoryName"
      :custom-selectable="true"
      show-select
    >
      <template v-slot:[`item.categoryName`]="{ item }">
        <span class="custom-font">{{ item.categoryName }}</span>
      </template>

      <template v-slot:[`item.unitPrice`]="{ item }">
        <span class="custom-font">{{ formatMoney(item.unitPrice) }}</span>
      </template>

      <template v-slot:[`item.cantidad`]="{ item }">
        <span class="custom-font">
          <input
            :class="[
              'inputCantidad',
              { 'inputCantidad-disabled': !isSelected(item) },
            ]"
            :disabled="!isSelected(item)"
            placeholder="0"
            type="number"
            min="0"
            v-model.number="item.cantidad"
            @input="calculatorSubtotal($event, item)"
          />
        </span>
      </template>

      <template v-slot:[`item.subtotal`]="{ item }">
        <span
          class="custom-font"
          v-if="!item.cantidad || selected.length == 0"
          >{{ formatMoney(0) }}</span
        >
        <span class="custom-font" v-else>{{ item.subtotalFormatted }}</span>
      </template>
    </v-data-table>
    <p class="subtotal" v-if="selected.length == 0">
      Sub Total: {{ formatMoney(0) }}
    </p>
    <p class="subtotal" v-else>
      Sub Total: {{ formatMoney(this.sumaSubTotal) }}
    </p>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      :retain-focus="false"
      persistent
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="selected.length > 0 && sumaSubTotal > 0 ? on : {}"
          x-medium
          fixed
          rounded
          bottom
          right
          dark
          :class="{
            'disabled-btn': selected.length === 0 || sumaSubTotal === 0,
            primary: selected.length > 0 && sumaSubTotal > 0,
          }"
          @click="handleButtonClick"
        >
          Siguiente
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark class="btn btn-primary" @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Métodos de pago</v-toolbar-title>

          <template v-slot:extension>
            <v-tabs v-model="tab" align-with-title>
              <v-tabs-slider color="accent"></v-tabs-slider>

              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tab" class="container mt-5">
          <v-tab-item>
            <div class="container mt-4">
              <paymentMethods />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import paymentMethods from "@/views/recognition/pages/payment_methods/components/payment_methods_component.vue";
import {
  ACTION_GET_CARDS,
  ACTION_GET_TABLE,
  RECOGNITION_BUYING_M,
  GET_CARDS,
  GET_TABLE,
  ACTION_POST_SEND,
} from "@/views/recognition/store/types/types.js";
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/utils/event_bus.js";

export default {
  name: "BuyRecognitionComponent",
  components: {
    paymentMethods,
  },
  data: () => ({
    dialog: false,
    sumaSubTotal: 0,
    selected: [],
    tab: null,
    items: ["Pago"],
    headers: [
      {
        text: "Categoría",
        value: "categoryName",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
      {
        text: "Valor Unitario",
        value: "unitPrice",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
      {
        text: "Cantidad",
        value: "cantidad",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
      {
        text: "Sub Total",
        value: "subtotal",
        align: "center",
        sortable: false,
        class:
          "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
      },
    ],
  }),

  async mounted() {
    await this.getCards();
    await this.getTable();
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      window.location.reload();
      this.resetData();
    },

    ...mapActions({
      getCards: `${RECOGNITION_BUYING_M}${ACTION_GET_CARDS}`,
      getTable: `${RECOGNITION_BUYING_M}${ACTION_GET_TABLE}`,
      postActionSend: `${RECOGNITION_BUYING_M}${ACTION_POST_SEND}`,
    }),

    handleButtonClick() {
      if (this.selected.length === 0 || this.sumaSubTotal === 0) {
        this.dialog = false;
      } else {
        this.dialog = true;
        this.submitForm();
      }
    },

    async submitForm() {
      const subTotal = parseFloat(this.sumaSubTotal).toFixed(2);
      const detail = this.selected.map((item) => ({
        categoryId: item.recognitionCategoryId,
        amount: item.cantidad,
      }));

      const payload = {
        subTotal,
        detail,
      };

      await this.postActionSend(payload);
      EventBus.$emit("send-success");
    },

    isSelected(item) {
      this.calculatorDeleteSubTotal(item);
      return this.selected.includes(item);
    },
    formatMoney(number) {
      return (
        "$" +
        number
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
    calculatorSubtotal(event, item) {
      item.subtotal = item.unitPrice * event.target.value;
      this.$set(item, "subtotalFormatted", this.formatMoney(item.subtotal));
      this.calculatorAdditionSubTotal(item, event.target.value);
    },
    calculatorAdditionSubTotal(item, cantidad) {
      const existingItemIndex = this.selected.findIndex(
        (element) => element.id === item.recognitionCategoryId
      );
      if (existingItemIndex !== -1) {
        this.selected[existingItemIndex].cantidad = cantidad;
      }
      this.sumaSubTotal = this.selected.reduce((sum, element) => {
        return sum + element.unitPrice * element.cantidad;
      }, 0);
      return this.sumaSubTotal;
    },
    calculatorDeleteSubTotal(item) {
      const existingItemIndex = this.selected.findIndex(
        (element) => element.id === item.recognitionCategoryId
      );
      if (existingItemIndex !== -1) {
        this.selected[existingItemIndex].cantidad = 0;
      }

      this.selected.forEach(() => {
        this.sumaSubTotal = this.selected.reduce((sum, element) => {
          if (element.cantidad) {
            return sum + element.unitPrice * element.cantidad;
          } else {
            return sum + element.unitPrice * 0;
          }
        }, 0);
      });
      return this.sumaSubTotal;
    },
  },
  computed: {
    ...mapGetters({
      cards: `${RECOGNITION_BUYING_M}${GET_CARDS}`,
      table: `${RECOGNITION_BUYING_M}${GET_TABLE}`,
    }),
  },
};
</script>

<style lang="css" scoped>
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.avatarStyle {
  background-color: white !important;
}

.icon-item {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-item img {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}

.cardStyle {
  border: 3px solid;
  border-color: #f2b37b;
  border-radius: 15px;
}

.headerBuyRecognition {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.custom-font {
  font-size: 20px;
}

.inputCantidad {
  text-align: center;
  color: #2d0049;
  border: 2px solid;
  border-radius: 10px;
  border-color: #6e17a5;
  background-color: #eadcf3;
}

.inputCantidad-disabled {
  color: #888;
  background-color: #f0f0f0;
  border-color: #ccc;
}

.subtotal {
  text-align: right;
  color: #6e17a5;
  padding: 0 60px;
  font-size: 23px;
  font-weight: 500;
}

.disabled-btn {
  background-color: #ccc !important;
  color: #fff !important;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  .custom-font {
    font-size: 13px;
  }

  .subtotal {
    text-align: right;
    color: #6e17a5;
    margin: auto;
    padding: 45px 10px;
    font-size: 23px;
    font-weight: 500;
  }
}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  h2 {
    font-size: 2vh;
  }

  .custom-font {
    font-size: 13px;
  }
}

.container {
  position: relative;
}

.v-btn.fixed {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000; /* Ajusta el z-index si es necesario para asegurar que esté sobre otros elementos */
}
</style>
